import { render, staticRenderFns } from "./mdModalEditTPProblem.vue?vue&type=template&id=c34bf72c&"
import script from "./mdModalEditTPProblem.vue?vue&type=script&lang=js&"
export * from "./mdModalEditTPProblem.vue?vue&type=script&lang=js&"
import style0 from "./mdModalEditTPProblem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports